import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@mui/material';
import UploadStatementComponent from '../../../components/payments/UploadStatementComponent';
import { EftStatementDto, ListEftStatementsResponse } from '../../../../models/EftStatement';
import { EftService } from '../../../../services/EftService';
import ErrorComponent from '../../../components/shared/ErrorComponent';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import LoadingComponent from '../../../components/shared/LoadingComponent';
import Typography from '@mui/material/Typography';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import AlertTitle from '@mui/material/AlertTitle';
import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';

const StatementsPage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [statements, setStatements] = useState<EftStatementDto[]>([]);
  const [isStatementUploadDialogOpen, toggleStatementUploadDialog] = useState<boolean>(false);

  /*
  const loadEFTStatements = async () => {
    try {
      setIsLoading(true);
      const response: ListEftStatementsResponse = await EftService.listStatementFiles();
      setIsLoaded(true);
      setStatements(response.eftStatements);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

   */

  const closeStatementDialog = (show: boolean): void => {
    toggleStatementUploadDialog(show);
  };

  const history = useHistory();
  const goTo = (location: string) => {
    history.push(location);
  };

  /* 828
  useEffect(() => {
    if (!isLoading && !isLoaded && !error) {
      loadEFTStatements();
    }
  }, [isLoaded, isLoading, error]);
   */
  const handleViewStatement = (statement: any) => {
    history.push(`/app/finance-area/statements/${statement.id}`);
  };

  const columns: GridColDef[] = [
    {
      field: '',
      headerName: 'View',
      flex: 15,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div>
            <Button variant="outlined" onClick={event => handleViewStatement(params.row)}>
              View
            </Button>
          </div>
        );
      }
    },
    { field: 'id', headerName: 'Id', flex: 10, editable: false },
    {
      field: 'statementFilename',
      headerName: 'Statement',
      flex: 100,
      editable: false
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 30,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Chip label={params.row.status} variant={'outlined'} />
        )
      }
    },
    {
      field: 'recordCount',
      headerName: '#Records',
      flex: 20,
      editable: false
    },
    {
      field: 'rawNumberLines',
      headerName: '#Lines',
      flex: 20,
      editable: false
    },
    {
      field: 'statementDate',
      headerName: 'Uploaded At',
      flex: 40,
      editable: false
    }
  ];

  return (
    <React.Fragment>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant={'h4'}>Eft Statement Management</Typography>
        <Button variant={'text'} type="button" onClick={() => { goTo('/app/finance-area') }}>
          <HomeIcon/>
        </Button>
      </Box>
          <Paper>
            <Box sx={{ p: 4, mt: 3 }}>
              {isLoading && <LoadingComponent />}
              {error && <ErrorComponent message={error} />}

              {isLoaded && statements.length === 0 && (
                <Alert severity="warning" variant="outlined">
                  <AlertTitle>EFT statements</AlertTitle>
                  There are currently no EFT statements.
                </Alert>
              )}
              {isLoaded && statements && statements.length > 0 && (
                <div style={{ height: 500 }}>
                  <DataGrid rows={statements} columns={columns} components={{}} />
                </div>
              )}
            </Box>
            <Box sx={{ p: 4, mt: 3, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Button variant={'contained'} onClick={() => closeStatementDialog(true)}>
                  Upload New Statement
                </Button>
            </Box>
          </Paper>
      <UploadStatementComponent onClose={closeStatementDialog} show={isStatementUploadDialogOpen} />
    </React.Fragment>
  );
};

export default StatementsPage;
